import React, { useState, useEffect, useRef } from "react";
import ChatService from "../../services/ChatService";
import { useSelector, useDispatch } from "react-redux";
import { fetchMessages } from "../../redux/slices/messagesSlice";
import { formatDateVietNam } from "../../Helpers/BaseHelper";

const ChatHistorybody = ({ chatRoomId, userChatWith, userInfo }) => {
  const { messages, searchTerm } = useSelector((state) => state.messages);
  const dispatch = useDispatch();
  const chatContainerRef = useRef(null);

  const scrollToBottom = () => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };
  useEffect(() => {
    if (!chatRoomId) return;

    if (chatRoomId) {
      dispatch(fetchMessages(chatRoomId)); // 🚀 Gọi API lấy tin nhắn
    }

    // ✅ Kết nối SignalR nếu chưa kết nối
    ChatService.startConnection((message) => {
      console.log(message, "message In chat history");
    });
    console.log(chatRoomId, "chatRoomId");
    if (chatRoomId) {
      ChatService.joinChatRoom(chatRoomId);
    }

    return () => {
      ChatService.leaveChatRoom(chatRoomId);
      ChatService.stopConnection();
    };
  }, [chatRoomId, dispatch]);

  useEffect(() => {
    scrollToBottom();
    console.log("🔄 SignalR state:", ChatService.connection?.state);
  }, [messages, searchTerm]);

  // 🔍 Lọc tin nhắn theo nội dung
  const filteredMessages = messages.filter((msg) =>
    msg.content.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="card-body msg_card_body chat-scroll" ref={chatContainerRef}>
      {console.log(messages, "messages")}
      <ul className="list-unstyled">
        {filteredMessages.map((element, index) => {
          if (+element.senderId === +userChatWith.id) {
            return (
              <li className="media received" key={index}>
                <div className="d-flex align-items-center mb-1">
                  <div className="avatar avatar-lg flex-shrink-0 me-2">
                    <img src={userChatWith.imageUrl} alt="User Image " />
                  </div>
                  <div>
                    <h6 className="fs-16 fw-normal d-flex align-items-center">
                      {userChatWith.fullName}
                    </h6>
                    <div className="d-flex justify-content-start">
                      <p className="fs-12">
                        {formatDateVietNam(element.sentAt)}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="media-body flex-grow-1">
                  <div className="msg-box">
                    <div className="position-relative">
                      <div className="d-flex align-items-center ">
                        <div className="received-message me-2">
                          <p className="fs-14">{element.content}</p>
                        </div>
                        <div className="chat-actions me-2">
                          <a href="#" data-bs-toggle="dropdown">
                            <i className="fa-solid fa-ellipsis-vertical"></i>
                          </a>
                          <ul className="dropdown-menu dropdown-menu-end p-3">
                            <li>
                              <a className="dropdown-item reply-btn" href="#">
                                <i className="isax isax-back-square me-2"></i>
                                Reply
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                <i className="fa-regular fa-share-from-square me-2"></i>
                                Forward
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                <i className="isax isax-copy me-2"></i>Copy
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                <i className="isax isax-heart me-2"></i>Mark as
                                Favourite
                              </a>
                            </li>
                            <li>
                              <a
                                className="dropdown-item"
                                href="#"
                                data-bs-toggle="modal"
                                data-bs-target="#message-delete"
                              >
                                <i className="isax isax-trash me-2"></i>Delete
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                <i className="fa-solid fa-check me-2"></i>Mark
                                as Unread
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                <i className="isax isax-archive-1 me-2"></i>
                                Archeive Chat
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                <i className="fa-solid fa-thumbtack me-2"></i>
                                Pin Chat
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            );
          } else if (+element.senderId === +userInfo.id) {
            return (
              <li className="sent-message-group" key={index}>
                <ul>
                  <li className="media sent d-flex align-items-end">
                    <div className="media-body flex-grow-1">
                      <div className="msg-box">
                        <div className="d-flex align-items-center justify-content-end mb-1">
                          <div>
                            <h6 className="fs-16 fw-normal d-flex align-items-center">
                              {userInfo.fullName}
                            </h6>
                            <div className="d-flex justify-content-end">
                              <p className="fs-12">
                                {formatDateVietNam(element.sentAt)}{" "}
                                <i className="ms-1 text-success fa-solid fa-check-double"></i>
                              </p>
                            </div>
                          </div>
                          <div className="ms-2">
                            <img
                              src={userInfo.imageUrl}
                              alt="image"
                              className="avatar avatar-lg"
                            />
                          </div>
                        </div>
                        <div className="position-relative">
                          <div className="d-flex align-items-center">
                            <div className="chat-actions me-2">
                              <a href="#" data-bs-toggle="dropdown">
                                <i className="fa-solid fa-ellipsis-vertical"></i>
                              </a>
                              <ul className="dropdown-menu dropdown-menu-end p-3">
                                <li>
                                  <a
                                    className="dropdown-item reply-btn"
                                    href="#"
                                  >
                                    <i className="isax isax-back-square me-2"></i>
                                    Reply
                                  </a>
                                </li>
                                <li>
                                  <a className="dropdown-item" href="#">
                                    <i className="fa-regular fa-share-from-square me-2"></i>
                                    Forward
                                  </a>
                                </li>
                                <li>
                                  <a className="dropdown-item" href="#">
                                    <i className="isax isax-copy me-2"></i>Copy
                                  </a>
                                </li>
                                <li>
                                  <a className="dropdown-item" href="#">
                                    <i className="isax isax-heart me-2"></i>Mark
                                    as Favourite
                                  </a>
                                </li>
                                <li>
                                  <a
                                    className="dropdown-item"
                                    href="#"
                                    data-bs-toggle="modal"
                                    data-bs-target="#message-delete"
                                  >
                                    <i className="isax isax-trash me-2"></i>
                                    Delete
                                  </a>
                                </li>
                                <li>
                                  <a className="dropdown-item" href="#">
                                    <i className="fa-solid fa-check me-2"></i>
                                    Mark as Unread
                                  </a>
                                </li>
                                <li>
                                  <a className="dropdown-item" href="#">
                                    <i className="isax isax-archive-1 me-2"></i>
                                    Archeive Chat
                                  </a>
                                </li>
                                <li>
                                  <a className="dropdown-item" href="#">
                                    <i className="fa-solid fa-thumbtack me-2"></i>
                                    Pin Chat
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div className="sent-message">
                              <p className="fs-14">
                                {element.content || element}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </li>
            );
          }
        })}

        {/* <li className="media received">
          <div className="d-flex align-items-center mb-1">
            <div className="avatar avatar-lg flex-shrink-0 me-2">
              <img src="assets/img/users/user-08.jpg" alt="User Image " />
            </div>
            <div>
              <h6 className="fs-16 fw-normal d-flex align-items-center">
                Beth Williams
              </h6>
              <div className="d-flex justify-content-start">
                <p className="fs-12">11:00 AM</p>
              </div>
            </div>
          </div>
          <div className="media-body flex-grow-1">
            <div className="msg-box">
              <div className="position-relative">
                <div className="d-flex align-items-center ">
                  <div className="received-message me-2">
                    <p className="fs-14">
                      Yes, we do! We have a 7-day Caribbean cruise that includes
                      stops in the Bahamas, Jamaica, and Cozumel, Mexico. It
                      departs on December 15. Would this be of interest?
                    </p>
                  </div>
                  <div className="chat-actions me-2">
                    <a href="#" data-bs-toggle="dropdown">
                      <i className="fa-solid fa-ellipsis-vertical"></i>
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                      <li>
                        <a className="dropdown-item reply-btn" href="#">
                          <i className="isax isax-back-square me-2"></i>Reply
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          <i className="fa-regular fa-share-from-square me-2"></i>
                          Forward
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          <i className="isax isax-copy me-2"></i>Copy
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          <i className="isax isax-heart me-2"></i>Mark as
                          Favourite
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="#"
                          data-bs-toggle="modal"
                          data-bs-target="#message-delete"
                        >
                          <i className="isax isax-trash me-2"></i>Delete
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          <i className="fa-solid fa-check me-2"></i>Mark as
                          Unread
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          <i className="isax isax-archive-1 me-2"></i>Archeive
                          Chat
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          <i className="fa-solid fa-thumbtack me-2"></i>Pin Chat
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li className="sent-message-group">
          <ul>
            <li className="media sent d-flex align-items-end">
              <div className="media-body flex-grow-1">
                <div className="msg-box">
                  <div className="d-flex align-items-center justify-content-end mb-1">
                    <div>
                      <h6 className="fs-16 fw-normal d-flex align-items-center">
                        Chris Foxy
                      </h6>
                      <div className="d-flex justify-content-end">
                        <p className="fs-12">
                          11:05 AM
                          <i className="ms-1 text-success fa-solid fa-check-double"></i>
                        </p>
                      </div>
                    </div>
                    <div className="ms-2">
                      <img
                        src="assets/img/users/user-lg-26.jpg"
                        alt="image"
                        className="avatar avatar-lg"
                      />
                    </div>
                  </div>
                  <div className="position-relative">
                    <div className="d-flex align-items-center">
                      <div className="chat-actions me-2">
                        <a href="#" data-bs-toggle="dropdown">
                          <i className="fa-solid fa-ellipsis-vertical"></i>
                        </a>
                        <ul className="dropdown-menu dropdown-menu-end p-3">
                          <li>
                            <a className="dropdown-item reply-btn" href="#">
                              <i className="isax isax-back-square me-2"></i>
                              Reply
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              <i className="fa-regular fa-share-from-square me-2"></i>
                              Forward
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              <i className="isax isax-copy me-2"></i>Copy
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              <i className="isax isax-heart me-2"></i>Mark as
                              Favourite
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item"
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#message-delete"
                            >
                              <i className="isax isax-trash me-2"></i>Delete
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              <i className="fa-solid fa-check me-2"></i>Mark as
                              Unread
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              <i className="isax isax-archive-1 me-2"></i>
                              Archeive Chat
                            </a>
                          </li>
                          <li>
                            <a className="dropdown-item" href="#">
                              <i className="fa-solid fa-thumbtack me-2"></i>Pin
                              Chat
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="sent-message">
                        <p className="fs-14">
                          That sounds perfect! Could you tell me about the cabin
                          options and pricing?
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </li>
        <li className="media received">
          <div className="d-flex align-items-center mb-1">
            <div className="avatar avatar-lg flex-shrink-0 me-2">
              <img src="assets/img/users/user-08.jpg" alt="User Image " />
            </div>
            <div>
              <h6 className="fs-16 fw-normal d-flex align-items-center">
                Beth Williams
              </h6>
              <div className="d-flex justify-content-start">
                <p className="fs-12">11:10 AM</p>
              </div>
            </div>
          </div>
          <div className="media-body flex-grow-1">
            <div className="msg-box">
              <div className="position-relative">
                <div className="d-flex align-items-center">
                  <div className="received-message me-2">
                    <p className="fs-14">
                      Of course. We offer the following cabin options
                    </p>
                    <div className="d-flex align-items-center">
                      <a href="#">
                        <img
                          src="assets/img/cruise/cruise-14.jpg"
                          alt="image"
                          className="avatar avatar-xxl me-2"
                        />
                      </a>
                      <a href="#">
                        <img
                          src="assets/img/cruise/cruise-29.jpg"
                          alt="image"
                          className="avatar avatar-xxl me-2"
                        />
                      </a>
                      <div className="img-count">
                        <a href="#">
                          <img
                            src="assets/img/cruise/cruise-13.jpg"
                            alt="image"
                            className="avatar avatar-xxl me-2"
                          />
                        </a>
                        <a href="#">
                          <span className="fs-16 fw-medium text-white counts">
                            10+
                          </span>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="chat-actions me-2">
                    <a href="#" data-bs-toggle="dropdown">
                      <i className="fa-solid fa-ellipsis-vertical"></i>
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end p-3">
                      <li>
                        <a className="dropdown-item reply-btn" href="#">
                          <i className="isax isax-back-square me-2"></i>Reply
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          <i className="fa-regular fa-share-from-square me-2"></i>
                          Forward
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          <i className="isax isax-copy me-2"></i>Copy
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          <i className="isax isax-heart me-2"></i>Mark as
                          Favourite
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item"
                          href="#"
                          data-bs-toggle="modal"
                          data-bs-target="#message-delete"
                        >
                          <i className="isax isax-trash me-2"></i>Delete
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          <i className="fa-solid fa-check me-2"></i>Mark as
                          Unread
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          <i className="isax isax-archive-1 me-2"></i>Archeive
                          Chat
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#">
                          <i className="fa-solid fa-thumbtack me-2"></i>Pin Chat
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-end">
                  <a href="#">
                    <span>
                      <img src="assets/img/icons/thumbs-up.svg" alt="image" />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </li> */}
      </ul>
    </div>
  );
};

export default ChatHistorybody;
